import LANGUAGE_CONTROLLER from '../controllers/languages';
import {Enum} from 'enumify';
import Countries from '../components/selectors/country/countries.json';

export default {

  // Used in URIs
  getFilingNameForUrlFromFilingTypeId(filingTypeId) {
    switch (filingTypeId+'') {
      case FilingTypeEnum.VATRETURN:
        return 'VAT';
      case FilingTypeEnum.ECLISTING:
        return 'ECListing';
      case FilingTypeEnum.ECLISTINGCORRECTION:
        return 'ECListingCorrection';
      case FilingTypeEnum.REFUND:
        return 'Refund';
      case FilingTypeEnum.LOCALLISTING:
        return 'LocalListing';
      case FilingTypeEnum.REVERSECHARGELISTING:
        return 'ReverseChargeListing';
      case FilingTypeEnum.OFFICIALLEDGER:
        return 'OfficialLedger';
      case FilingTypeEnum.EXTRASTAT:
        return 'Extrastat';
      case FilingTypeEnum.INTRASTAT:
        return 'Intrastat';
      case FilingTypeEnum.VATBOOKS:
        return 'VATBook';
      case FilingTypeEnum.OSSIMPORT:
          return 'ossImport';
      case FilingTypeEnum.OSSUNION:
          return 'ossUnion';
      case FilingTypeEnum.OSSNONUNION:
         return 'ossNonUnion';
      default:
        return 'Unknown filingTypeId '+filingTypeId;
    }
  },
  getFilingTypeFromSubType(subTypeText) {
    const availableFilingTypes = [
      FilingTypeEnum.VATRETURN,
      FilingTypeEnum.ECLISTING,
      FilingTypeEnum.ECLISTINGCORRECTION,
      FilingTypeEnum.REFUND,
      FilingTypeEnum.LOCALLISTING,
      FilingTypeEnum.REVERSECHARGELISTING,
      FilingTypeEnum.OFFICIALLEDGER,
      FilingTypeEnum.EXTRASTAT,
      FilingTypeEnum.INTRASTAT,
      FilingTypeEnum.VATBOOKS,
      FilingTypeEnum.OSSUNION,
      FilingTypeEnum.OSSNONUNION,
      FilingTypeEnum.OSSIMPORT
    ];
    return availableFilingTypes.find(item => {
      const fileType = this.getFilingNameFromFilingType(item);
      return subTypeText?.startsWith(fileType);
    });
  },
  // filingNames are what appear in openReturns
  getFilingNameFromFilingType(filingType) {
    switch (filingType) {
      case FilingTypeEnum.VATRETURN:
        return 'VAT Return';
      case FilingTypeEnum.ECLISTING:
        return 'EC Listing';
      case FilingTypeEnum.ECLISTINGCORRECTION:
        return 'EC Listing correction';
      case FilingTypeEnum.REFUND:
        return 'Refund';
      case FilingTypeEnum.LOCALLISTING:
        return 'Local Listing';
      case FilingTypeEnum.REVERSECHARGELISTING:
        return 'Reverse Charge Listing';
      case FilingTypeEnum.OFFICIALLEDGER:
        return 'Official Ledger';
      case FilingTypeEnum.EXTRASTAT:
        return 'Extrastat';
      case FilingTypeEnum.INTRASTAT:
        return 'Intrastat';
      case FilingTypeEnum.VATBOOKS:
        return 'VAT Book';
      case FilingTypeEnum.OSSUNION:
         return 'OSS Union';
      case FilingTypeEnum.OSSNONUNION:
         return 'OSS Non Union';
      case FilingTypeEnum.OSSIMPORT:
          return 'OSS Import';
      default:
        return 'Unknown filingTypeId ' + filingType;
    }
  },
  getIntrastatFlowNameFromFlowType(flowType) {
    switch (flowType) {
      case IntrastatFlowEnum.NONE:
        return '';
      case IntrastatFlowEnum.PURCHASES:
        return 'In'
      case IntrastatFlowEnum.SALES:
        return 'Out'
      case IntrastatFlowEnum.CORRECTIONS:
        return ''
      default:
          return 'Unknown flowType '+ flowType;
    }
  },
  getIntrastatReturnTypeDisplay(returnType) {
    const intrastatTypes = {
      0: 'Intrastat Out',
      1: 'Intrastat In'
    };
    return intrastatTypes[returnType] || 'Intrastat';
  },
  fixFilingName(filingName){
    switch (filingName) {
      case 'VAT return':
        return 'VAT Return';
      case 'EC listing':
        return 'EC Listing';
      case 'EC listing correction':
        return 'EC Listing Correction';
      case 'Local listing':
        return 'Local Listing';
      case 'Reverse charge listing':
        return 'Reverse Charge Listing';
      case 'Official ledger':
        return 'Official Ledger';
      case 'VAT book':
        return 'VAT Book';
      default:
        return filingName;
    }
  },

  getFilingTypeIdFromName(filingName) {
    filingName = typeof filingName === 'string' ? filingName : 'unknown';
    switch (filingName.toLowerCase()) {
      case 'vat return':
        return FilingTypeEnum.VATRETURN;
      case 'ec listing':
      case 'ic listing':
        return FilingTypeEnum.ECLISTING;
      case 'ec listing correction':
      case 'ic listing correction':
        return FilingTypeEnum.ECLISTINGCORRECTION;
      case 'refund':
        return FilingTypeEnum.REFUND;
      case 'local listing':
        return FilingTypeEnum.LOCALLISTING;
      case 'reverse charge listing':
      case 'local listing reverse charge':
        return FilingTypeEnum.REVERSECHARGELISTING;
      case 'official ledger':
        return FilingTypeEnum.OFFICIALLEDGER;
      case 'extrastat':
        return FilingTypeEnum.EXTRASTAT;
      case 'intrastat':
      case 'intrastat in':
      case 'intrastat out':
        return FilingTypeEnum.INTRASTAT;
      case 'vat book':
        return FilingTypeEnum.VATBOOKS;
      case 'oss import':
        return FilingTypeEnum.OSSIMPORT;
      case 'oss non union':
          return FilingTypeEnum.OSSNONUNION;
      case 'oss union':
         return FilingTypeEnum.OSSUNION;
      default:
        return 'Unknown filingName '+filingName;
    }
  },

  getOSSReportTypeIdFromFilingTypeId(filingTypeId) {
      switch (filingTypeId+'') {
          case FilingTypeEnum.OSSUNION:
              return 1;
          case FilingTypeEnum.OSSNONUNION:
              return 2;
          case FilingTypeEnum.OSSIMPORT:
              return 3;
          default:
              return -1
      }
  },
  getIntrastatFlowFromName(filingName) {
    filingName = typeof filingName === 'string' ? filingName : 'unknown';
    switch (filingName.toLowerCase()) {
      case 'intrastat in':
        return IntrastatFlowEnum.PURCHASES
      case 'intrastat out':
        return IntrastatFlowEnum.SALES
      default:
        return 'Unknown filingName '+filingName;
    }
  },

    //Method to get frequency id from returnPeriodTimeType from company setup
    getVATFrequencyId(frequency)
    {
       switch (frequency){
           case 0 :
             return 1;
           case 1:
             return 2;
           case 5:
             return 3;
           case 4:
             return 7;
           // bi monthly
           case 6:
             return 8;
           //half yearly
           case 7:
             return 9;
           //Four monthly
           case 8:
             return 10;
           default:
             return -1;
       }
    },
    //Method to get frequency offset from frequencyPeriod from company setup
    getFrequencyOffset(frequencyPeriod)
    {
        switch(frequencyPeriod)
        {
            case 'Monthly':
                return 1;
            case 'Bi-Monthly':
                return 2;
            case 'Quarterly':
                return 3;
            case 'Half-Yearly':
                return 6;
            case 'Yearly 2 (Dynamic)':
            case 'Yearly 2':
                return 24;
            case 'Yearly' :
            case 'Yearly (Dynamic)':
                return 12 ;
            case 'Four-monthly':
                return 4;
            default:
                return -1;
        }
    },
    //Method to get frequency id from ecListingFrequency from company setup
    getECListingFrequencyId(frequency)
    {
        switch (frequency){
            case 1 :
                return 1;
            case 2:
                return 8;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 9;
            case 6:
                return 7;
        }
    },

    //Method to get frequency id from localListingFrequency from company setup
    getLocalListingFrequencyId(frequency)
    {
        switch (frequency){
            case 1 :
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            case 4:
                return 9;
            case 5:
                return 7;
        }
    },

    //Method to get frequency id from intrastatInFrequency/intrastatOutFrequency from company setup
    getIntrastatFrequencyId(frequency)
    {
        switch (frequency){
            case 1 :
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            case 4:
                return 7;
        }
    },

    //Method to get frequency id from returnPeriodTimeType from company setup
    getOSSImportFrequencyId(frequency)
    {
        if(frequency === 1)
            return frequency;
        else
            return -1;
    },

    getOSSFrequencyId(frequency)
    {
        if(frequency === 1)
            return 2;
        else
            return -1;
    },
  getPeriodNameFromPeriodId(id) {
    switch (id+'') {
      case '0':
        return 'Month';
      case '1':
        return 'Quarter';
      case '2':
        return 'Year';
      case '3':
        return 'Year2';
      case '4':
        return 'Bi Monthly';
      case '5':
        return 'Half Year';
     case '6':
         return 'Four-monthly';
      default:
        return 'Unknown periodId '+id;
    }
  },
  getOutputTypeFromId(id) {
    switch (id+'') {
      case '1':
        return 'PDF';
      case '2':
        return 'XML';
      case '3':
        return 'FixedFormat';
      default:
        return 'Unknown outputTypeId '+id;

    }
  },
  getPeriodicityFromId(id) {
    switch (id+'') {
      case '0':
        return 'No Period';
      case '1':
        return 'Monthly';
      case '2':
        return 'Quarterly';
      case '3':
        return 'Yearly';
      case '4':
        return 'Yearly 2';
      case '5':
        return 'Yearly (Dynamic)';
      case '6':
        return 'Yearly 2 (Dynamic)';
      case '7':
        return 'No Filing';
      case '8':
        return 'Bi-Monthly';
      case '9':
        return 'Half-Yearly';
      case '10':
         return 'Four-monthly';
      case '11':
            return 'YearlyDynamicQuick';
      case '12':
            return 'YearlyDynamic2Quick';
      default:
        return 'Unknown Periodicity id '+id;
    }
  },
  getVATBoxTypeFromId(id) {
    switch (id+'') {
      case '0':
        return 'Taxable Basis';
      case '1':
        return 'VAT';
      default:
        return 'Unknown VAT box type '+id;
    }
  },

  /*
    Converts a value from filingFrequencies to formXmlfilingFrequencies.
    The FormXml's use their own enumeration of frequencies
  */
  ReportPeriodicityToFormXmlPeriodicity: (reportPeriodicity) => {
    switch(reportPeriodicity)
    {
      case 2:
          return 1;
      case 3:
      case 5:
          return 2;
      case 4:
      case 6:
          return 3;
      case 8:
          return 4;
      case 9:
          return 5;
      case 10:
          return 6;
    default:
      return 0;
    }
  },

  GetApplicableVatBookFlowTypes: (country) => {
    let result = {
      isApplicable: true,
      flowTypes: []
    }

    switch(country.toUpperCase())
    {
      case "SA":
        result.flowTypes = [VATBookFlowEnum.SALES, VATBookFlowEnum.PURCHASES, VATBookFlowEnum.COMBINED];
        break;
      case "IT":
        result.flowTypes = [VATBookFlowEnum.SALES, VATBookFlowEnum.PURCHASES];
        break;
      default:
        result.isApplicable = false;
        break;
    }

    return result;
  },

  IsECListingFlowASalesTransaction: (ECListingFlowPerTransactionTypeEnum) => {
    return [ECListingFlowPerTransactionTypesEnum.SALES, ECListingFlowPerTransactionTypesEnum.SALES_GOODS,
              ECListingFlowPerTransactionTypesEnum.SALES_SERVICES]
      .find(item => item === ECListingFlowPerTransactionTypeEnum) !== undefined;
  },

  ConvertToECListingFlowEnum: (ECListingFlowPerTransactionTypeEnum) => {
    if ([ECListingFlowPerTransactionTypesEnum.SALES,
          ECListingFlowPerTransactionTypesEnum.SALES_GOODS,
          ECListingFlowPerTransactionTypesEnum.SALES_SERVICES]
      .find(item => item === ECListingFlowPerTransactionTypeEnum) !== undefined)
      {
        return ECListingFlowEnum.SALES;
      }
    if ([ECListingFlowPerTransactionTypesEnum.ACQUISITION,
          ECListingFlowPerTransactionTypesEnum.ACQUISITION,
          ECListingFlowPerTransactionTypesEnum.ACQUISITION]
      .find(item => item === ECListingFlowPerTransactionTypeEnum) !== undefined)
      {
        return ECListingFlowEnum.PURCHASES;
      }
    if ([ECListingFlowPerTransactionTypesEnum.COMBINED,
          ECListingFlowPerTransactionTypesEnum.COMBINED,
          ECListingFlowPerTransactionTypesEnum.COMBINED]
      .find(item => item === ECListingFlowPerTransactionTypeEnum) !== undefined)
      {
        return ECListingFlowEnum.COMBINED;
      }
    return undefined;
  },

  DetermineFlowEnumFromFilingType:(FilingTypeId, Flow) =>{
    switch(FilingTypeId) {
      case FilingTypeEnum.INTRASTAT:
        return IntrastatFlowEnum.props[Flow].value;
      case FilingTypeEnum.ECLISTING:
        return ECListingFlowEnum.props[Flow].value;
      case FilingTypeEnum.LOCALLISTING:
      case FilingTypeEnum.REVERSECHARGELISTING:
        return LocalListingFlowEnum.props[Flow].value;
      case FilingTypeEnum.VATBOOKS:
        return VATBookFlowEnum.props[Flow].value;
      case FilingTypeEnum.EXTRASTAT:
        return ExtrastatFlowEnum.props[Flow].value;
      default:
        return 1
    }
  },

  ValueToEnum: (value, toEnum, valueKey='value') => {
    return Object.keys(toEnum.props).find(key => toEnum.props[key][valueKey] === value);
  },

  GetAllEnumOptions: (enumType) => {  //Returns all the enum items for the specific enum type
    let keys = Object.keys(enumType);
    let filteredKeys = keys.filter(k => k !== 'props' && (enumType.props[enumType[k]] ? enumType.props[enumType[k]].show: false));
    return filteredKeys.map(k => enumType[k]);
  },

    getMonthNameFromNumber : (month) =>
    {
      switch(month)
      {
          case 1: return 'Jan';
          case 2: return 'Feb';
          case 3: return 'Mar';
          case 4: return 'Apr';
          case 5: return 'May';
          case 6: return 'Jun';
          case 7: return 'Jul';
          case 8: return 'Aug';
          case 9: return 'Sep';
          case 10: return 'Oct';
          case 11: return 'Nov';
          case 12: return 'Dec';
      }
    },
    getCurrencyPriorityList : () =>
    {
        //Currency Priority values from VR, no enum available with VR REST API
       return [2,3];
    }
}

export const ProductEnum =  Object.freeze({
  DEV_ONLY: "DevOnly",
  VAT_REPORTING: "VATReporting",
  LIVE_REPORTING: "LiveReporting",
  props: {
    "DevOnly" :{
      id: 0,
      description: "Internal dev only"
    },
    "VAT_REPORTING" : {
      id: 1,
      description: "VAT reporting product"
    },
    "LIVE_REPORTING" : {
      id: 2,
      description: "Live reporting product"
    },
  }
})

export const TransmissionStatusEnum = Object.freeze({
  NEW: "0",
  PREPARING_TO_SEND: "1",
  SENT_FAILED: "ERROR",
  SENT_SUCCEEDED: "OK",
  UNKNOWN: undefined,
  props: {
    "0": {
      languageString: "transmissionStatus_New"
    },
    "1": {
      languageString: "transmissionStatus_PreparingToSend"
    },
    "ERROR": {
      languageString: "transmissionStatus_SentFailed"
    },
    "OK": {
      languageString: "transmissionStatus_SendSuceeded"
    }
  }
});


export const TransmissionStatusResultEnum = Object.freeze({
  DONE: "DONE",
  ERROR: "ERROR",
  PENDING: "Pending",
  WARN: "WARN",
  ABORTED: "ABORTED",
  UNKNOWN: undefined,
  GROUP_FAILED: "FAILED",
  props: {
    "DONE": {
      xmlRoot: "QueryInvoiceStatusResponse"
    },
    "ERROR": {
      xmlRoot: "GeneralErrorResponse"
    },
    "PENDING": {
      xmlRoot: "ManageInvoiceResponse"
    },
    "WARN": {
      xmlRoot: "QueryInvoiceStatusResponse"
    },
    "ABORTED": {
      xmlRoot: "QueryInvoiceStatusResponse"
    }
  }
});

//Matches the TGenericFormIntrastatReturnTypes in Reporting.
export const IntrastatFlowEnum = Object.freeze({
  NONE: "None",
  SALES: "Sales",
  PURCHASES: "Purchases",
  CORRECTIONS: "Corrections",
  props: {
    "None": {
      value: 0
    },
    "Sales": {
      value: 1
    },
    "Purchases": {
      value: 2
    },
    "Corrections": {
      value: 3
    }
  }
});


//Matches the TGenericFormVATBookReturnTypes in Reporting.
export const VATBookFlowEnum = Object.freeze({
  NONE: "None",
  SALES: "Sales",
  PURCHASES: "Purchases",
  COMBINED: "Combined",
  props: {
    "None": {
      value: 0
    },
    "Sales": {
      value: 1
    },
    "Purchases": {
      value: 2
    },
    "Combined": {
      value: 3
    }
  }
});


//Matches the TGenericFormECListingReturnTypes in Reporting.
export const ECListingFlowEnum = Object.freeze({
  NONE: "None",
  SALES: "Sales",
  PURCHASES: "Purchases",
  COMBINED: "Combined",
  props: {
    "None": {
      value: 0
    },
    "Sales": {
      value: 1
    },
    "Purchases": {
      value: 2
    },
    "Combined": {
      value: 3
    }
  }
});

export const ECTypeEnums = Object.freeze({
  SALES: 'sales',
  PURCHASES: 'purchase',
  CALLOFSTOCKS: 'callOfStocks'
})
export const OssReturnEnum = Object.freeze({
    OSSUNION: "OSS Union",
    OSSNONUNION: "OSS Non-Union",
    OSSIMPORT: "OSS Import",
    props: {
        "OSS Union": {
            value: 1
        },
        "OSS Non-Union": {
            value: 2
        },
        "OSS Import": {
            value: 3
        }
    }
});

export const VATNumberChecksEnum = Object.freeze({
  NONE: "NONE",
  NOK: 'NOK',
  OK:'OK,',
  FAILED: "FAILED",
  NOT_CHECKED: "NOT_CHECKED",
  TECHNICAL: "TECHNICAL",
  getEnum: function(value) {
    let keys = Object.keys(this.props);
    let values = Object.values(this.props);
    let matchedIndex = values.findIndex(e => e.value === value);
    if(matchedIndex !== -1) {
      return keys[matchedIndex];
    } else {
      return 'MISSING';
    }
  },
  getValue: function(key) {
    return this[key] ? this.props[key].value : 'MISSING';
  },
  getString: function(key) {
    return this[key] ? this.props[key].string : 'MISSING';
  },
  getLanguageString: function(key) {
    return this[key] ? this.props[key].languageString : 'MISSING';
  },
  props: {
    NONE: {
      value: 0,
      languageString: 'vatNumberCheckStatus_None',
      string: 'None'
    },
    OK: {
      value: 1,
      languageString: 'vatNumberCheckStatus_OK',
      string: 'Ok'
    },
    NOK: {
      value: 2,
      languageString: 'vatNumberCheckStatus_NOK',
      string: 'Not Ok'
    },
    FAILED: {
      value: 3,
      languageString: 'vatNumberCheckStatus_FAILED',
      string: 'Failed'
    },
    NOT_CHECKED: {
      value: 4,
      languageString: 'vatNumberCheckStatus_NOT_CHECKED',
      string: 'Not Checked'
    },
    TECHNICAL: {
      value: 5,
      languageString: 'vatNumberCheckStatus_TECHNICAL',
      string: 'Technical Check'
    }
  }
});


//Matches TReportingStatus  in VAT Reporting
export const ReportingStatus = Object.freeze({
  OVERDUE: 'OVERDUE',
  READY_TO_BE_MADE: 'READY_TO_BE_MADE',
  MADE: 'MADE',
  TOO_EARLY: 'TOO_EARLY',
  NOT_NEEDED: 'NOT_NEEDED',
  BEFORE_CLOSING_DAY: 'BEFORE_CLOSING_DAY',
  ALMOST_OVERDUE: 'ALMOST_OVERDUE',
  UNKNOWN: 'UNKNOWN',
  NO_FILING: 'NO_FILING',
  //MISSING is a special value and does not have matching value in VR
  //It is used represent a missing reporting status value
  MISSING: 'MISSING',
  getEnum: function(value) {
    let keys = Object.keys(this.props);
    let values = Object.values(this.props);
    let matchedIndex = values.findIndex(e => e.value === value);
    if(matchedIndex !== -1) {
      return keys[matchedIndex];
    } else {
      return this.MISSING;
    }
  },
  getValue: function(key) {
    return this[key] ? this.props[key].value : this.MISSING;
  },
  getString: function(key) {
    return this[key] ? this.props[key].string : this.MISSING;
  },
  getLanguageString: function(key) {
    return this[key] ? this.props[key].languageString : this.MISSING;
  },
  getFormattedLanguageString: function(key, languages={}) {
    return this[key] ? LANGUAGE_CONTROLLER.format(languages, this.props[key].languageString): this.MISSING;
  },
  props: {
    OVERDUE: {
      value: 0,
      languageString: 'openReturnsStatus_overdue',
      string: 'Overdue'
    },
    READY_TO_BE_MADE: {
      value: 1,
      languageString: 'openReturnsStatus_ready',
      string: 'Ready'
    },
    MADE: {
      value: 2,
      languageString: 'openReturnsStatus_done',
      string: 'Done'
    },
    TOO_EARLY: {
      value: 3,
      languageString: 'openReturnsStatus_tooEarly',
      string: 'Too early'
    },
    NOT_NEEDED: {
      value: 4,
      languageString: 'openReturnsStatus_notNeeded',
      string: 'Not needed'
    },
    BEFORE_CLOSING_DAY: {
      value: 5,
      languageString: 'openReturnsStatus_beforeClosingDay',
      string: 'Before closing day'
    },
    ALMOST_OVERDUE: {
      value: 6,
      languageString: 'openReturnsStatus_almostOverdue',
      string: 'Almost overdue'
    },
    UNKNOWN: {
      value: 7,
      languageString: 'openReturnsStatus_unknown',
      string: 'Unknown'
    },
    NO_FILING: {
      value: 8,
      languageString: 'openReturnsStatus_noFiling',
      string: 'No filing'
    },
    MISSING: {}
  }
});


//Matches the TICListingType in Reporting.
export const ECListingFlowPerTransactionTypesEnum = Object.freeze({
  SALES: "Sales",
  ACQUISITION: "Acquisition",
  COMBINED: "Combined",
  SALES_GOODS: "SalesGoods",
  ACQUISITION_GOODS: "AcquisitionGoods",
  COMBINED_GOODS: "CombinedGoods",
  SALES_SERVICES: "SalesServices",
  ACQUISITION_SERVICES: "AcquisitionServices",
  COMBINED_SERVICES: "CombinedServices",
  props: {
    "Sales": {
      value: 0,
      languageString: 'ListingType_ECSalesListing'
    },
    "Acquisition": {
      value: 1,
      languageString: 'ListingType_ECAcquisitionListing'
    },
    "Combined": {
      value: 2,
      languageString: 'ListingType_ECCombinedListing'
    },
    "SalesGoods": {
      value: 3,
      languageString: 'ListingType_ECSalesGoodsListing'
    },
    "AcquisitionGoods": {
      value: 4,
      languageString: 'ListingType_ECAcquisitionGoodsListing'
    },
    "CombinedGoods": {
      value: 5,
      languageString: 'ListingType_ECCombinedGoodsListing'
    },
    "SalesServices": {
      value: 6,
      languageString: 'ListingType_ECSalesServicesListing'
    },
    "AcquisitionServices": {
      value: 7,
      languageString: 'ListingType_ECAcquisitionServicesListing'
    },
    "CombinedServices": {
      value: 8,
      languageString: 'ListingType_ECCombinedServicesListing'
    }
  }
});

export const FilingType = Object.freeze ({
    VAT: 'VAT',
    EC_LISTING: 'EC_LISTING',
    EC_LISTING_CORRECTIONS: 'EC_LISTING_CORRECTIONS',
    REFUND: 'REFUND',
    LOCAL_LISTING: 'LOCAL_LISTING',
    RESVERSE_CHARGE_LISTING: 'RESVERSE_CHARGE_LISTING',
    OFFICIAL_LEDGER: 'OFFICIAL_LEDGER',
    EXTRASTAT: 'EXTRASTAT',
    INTRASTAT: 'INTRASTAT',
    OSSUNION: 'OSSUNION',
    OSSNONUNION: 'OSSNONUNION',
    OSSIMPORT: 'OSSIMPORT',
    VATBOOK: 'VATBOOK',
    MISSING: 'MISSING',
    getEnum: function(value) {
      let keys = Object.keys(this.props);
      let values = Object.values(this.props);
      let matchedIndex = values.findIndex(e => e.value === value);
      if(matchedIndex !== -1) {
        return keys[matchedIndex];
      } else {
        return this.MISSING;
      }
    },
    getValue: function(key) {
      return this[key] ? this.props[key].value : this.MISSING;
    },
    getString: function(key) {
      return this[key] ? this.props[key].string : this.MISSING;
    },
    getLanguageString: function(key) {
      return this[key] ? this.props[key].languageString : this.MISSING;
    },
    props: {
      VAT: {
        value: 0,
        string: 'Vat',
        languageString: 'filingType_VAT'
      },
      EC_LISTING: {
        value: 1,
        string: 'ECListing',
        languageString: 'filingType_ECListing'
      },
      EC_LISTING_CORRECTIONS:  {
        value: 2,
        string: 'ECListingCorrection',
        languageString: 'filingType_ECListingCorrection'
      },
      REFUND:  {
        value: 3,
        string: 'Refund',
        languageString: 'filingType_Refund'
      },
      LOCAL_LISTING:  {
        value: 4,
        string: 'LocalListing',
        languageString: 'filingType_LocalListing'
      },
      RESVERSE_CHARGE_LISTING:  {
        value: 5,
        string: 'ReverseChargeListing',
        languageString: 'filingType_ReverseChargeListing'
      },
      OFFICIAL_LEDGER:  {
        value: 6,
        string: 'OfficialLedger',
        languageString: 'filingType_OfficialLedger'
      },
      EXTRASTAT:  {
        value: 7,
        string: 'Extrastat',
        languageString: 'filingType_Extrastat'
      },
      INTRASTAT:  {
        value: 8,
        string: 'Intrastat',
        languageString: 'filingType_Intrastat'
      },
      VATBOOK: {
        value: 9,
        string: 'VATBook',
        languageString: 'filingType_VATBook'
      },
        OSSUNION:  {
            value: 14,
            string: 'OSSUnion',
            languageString: 'filingType_OSSUnion'
        },
        OSSNONUNION:  {
            value: 13,
            string: 'OSSNonUnion',
            languageString: 'filingType_OSSNonUnion'
        },
        OSSIMPORT:  {
            value: 12,
            string: 'OSSImport',
            languageString: 'filingType_OSSImport'
        },
      MISSING:  {},
    }
  }
);

export const VATReturnType = Object.freeze({
  NORMAL: 'NORMAL',
  CORRECTION: 'CORRECTION',
  MISSING: 'MISSING',
  props: {
    NORMAL: {
      value: 0,
      name: "vrtNormal",
      string: 'Normal'
    },
    CORRECTION: {
      value: 1,
      name: "vrtCorrection",
      string: 'Correction'
    },
    MISSING:  {}
  },
  getEnum: function(value) {
    let keys = Object.keys(this.props);
    let values = Object.values(this.props);
    let matchedIndex = values.findIndex(e => e.value === value);
    if(matchedIndex !== -1) {
      return keys[matchedIndex];
    } else {
      return this.MISSING;
    }
  },
  getValue: function(key) {
    return this[key] ? this.props[key].value : this.MISSING;
  },
  getString: function(key) {
    return this[key] ? this.props[key].string : this.MISSING;
  }
});

//Matches the TGenericFormLocalListingReturnTypes in Reporting. This one is also used for ReverseChargeListing on the FormXml
export const LocalListingFlowEnum = Object.freeze({
  NONE: "None",
  SALES: "Sales",
  PURCHASES: "Purchases",
  COMBINED: "Combined",
  props: {
    "None": {
      value: 0
    },
    "Sales": {
      value: 1
    },
    "Purchases": {
      value: 2
    },
    "Combined": {
      value: 3
    }
  }
});

export const UserFormModeEnum = Object.freeze({
  CREATE: "Create",
  EDIT: "Edit",
 });

 export const NewUploadEnum = Object.freeze({
  ACCORDION_STATE: "accordionState",
  EXPANDED: "expanded",
  COLLAPSED: "collapsed",
 });

export const ExtrastatFlowEnum = Object.freeze({
  NONE:"None",
  SALES: "Sales",
  PURCHASES: "Purchases",
  COMBINED: "Combined",
  props: {
    "None": {
      value: 0
    },
    "Sales": {
      value: 1,
      languageString: 'ListingType_ExtrastatSale'
    },
    "Purchases": {
      value: 2,
      languageString: 'ListingType_ExtrastatPurchases'
    },
    "Combined": {
      value: 3,
      languageString: 'ListingType_ExtrastatCombined'
    }
  }
});

export const FilingFileExtention = Object.freeze({
  XML:"xml",
  CSV:"csv",
  TXT:"txt",
  PDF:"pdf",
  FIXEDFORMAT:"FixedFormat"
});

/**
 * With introduction the new version obligations API.
 * FilingTypeEnum can no longer be shared between obligations and options API.
 * FilingOptions return types differ from the obligations return type,
 * hence new  `filingOptionValue` has been added to only to the supported enum types.
 */
export const FilingTypeEnum = Object.freeze({
  parseString: function (value) {
    switch (value.toLowerCase()) {
      case "vat":
        return this.VATRETURN;
      case "eclisting":
        return this.ECLISTING;
      case "locallisting":
        return this.LOCALLISTING;
      case "reversechargelisting":
        return this.REVERSECHARGELISTING;
      case "extrastat":
        return this.EXTRASTAT;
      case "intrastat":
        return this.INTRASTAT;
      case "vatbook":
        return this.VATBOOKS;
      case "ossimport":
        return this.OSSIMPORT;
      case "ossunion":
        return this.OSSUNION;
      case "ossnonunion":
        return this.OSSNONUNION;
      case "eclistingcorrection":
      case "refund":
      case "officialledger":
      case "refund13":
        return undefined;
    }
  },
  VATRETURN: "VATReturn",
  ECLISTING: "ECListing",
  LOCALLISTING: "LocalListing",
  REVERSECHARGELISTING: "ReverseChargeListing",
  EXTRASTAT: "Extrastat",
  VATBOOKS: "VATBook",
  INTRASTAT_IN: "IntrastatIn",
  INTRASTAT_OUT: "IntrastatOut",
  INTRASTAT: "Intrastat",
  OSSUNION: "OSSUnion",
  OSSNONUNION: "OSSNonUnion",
  OSSIMPORT: "OSSImport",
  props: {
    VATReturn: {
      value: 0,
      filingOptionValue: 0,
      show: true,
    },
    Intrastat: {
      value: 1,
      filingOptionValue: 7,
      show: true,
    },
    ECListing: {
      value: 2,
      filingOptionValue: 1,
      show: true,
    },
    LocalListing: {
      value: 3,
      filingOptionValue: 3,
      show: true,
    },
    ReverseChargeListing: {
      value: 5,
      filingOptionValue: 4,
      show: true,
    },
    Extrastat: {
      value: 6,
      filingOptionValue: 6,
      show: true,
    },
    IntrastatIn: {
      value: 7,
      show: false,
    },
    IntrastatOut: {
      value: 8,
      show: false,
    },
    VATBook: {
      value: 10,
      filingOptionValue: 9,
      show: true,
    },
    OSSUnion: {
      value: 14,
      filingOptionValue: 14,
      show: true,
    },
    OSSNonUnion: {
      value: 13,
      filingOptionValue: 13,
      show: true,
    },
    OSSImport: {
      value: 12,
      filingOptionValue: 15,
      show: true,
    },
    All: {
      value: -1,
      show: true,
    },
  },
});

export class AnalysisType extends Enum{}
AnalysisType.initEnum({
  VAT_CODE: {
    value: 0,
    languageString: "analysisType_VATCode",
  },
  VAT_CODE_GENERIC: {
    value: 1,
    languageString: "analysisType_VATCodeGeneric",
  },
  BOOKING_INFORMATION: {
    value: 2,
    languageString: "analysisType_BookingInformation"
  },
  ACCOUNT_NUMBER: {
    value: 3,
    languageString: "analysisType_AccountNumber"
  },
  ACCOUNT_NUMBER_VAT: {
    value: 4,
    languageString: "analysisType_AccountNumberVAT"
  },
  ACCOUNT_NUMBER_DEDUCT_VAT: {
    value: 5,
    languageString: "analysisType_AccountNumberDeductVAT"
  },
  ACCOUNT_NUMBER_NON_DEDUCT_VAT: {
    value: 6,
    languageString: "analysisType_AccountNumberNonDeductVAT"
  },
  ACCOUNT_NUMBER_REVERSED_VAT: {
    value: 7,
    languageString: "analysisType_AccountNumberReversedVAT"
  }
});

export class AnalysisTypeMainVATCodeOnly extends Enum{}
AnalysisTypeMainVATCodeOnly.initEnum({
  VAT_CODE: {
    value: 8,
    languageString: "analysisType_VATCode"
  },
  VAT_CODE_GENERIC: {
    value: 9,
    languageString: "analysisType_VATCodeGeneric"
  },
  ACCOUNT_NUMBER: {
    value: 10,
    languageString: "analysisType_AccountNumber"
  },
  ACCOUNT_NUMBER_VAT: {
    value: 11,
    languageString: "analysisType_AccountNumberVAT"
  },
  ACCOUNT_NUMBER_DEDUCT_VAT: {
    value: 12,
    languageString: "analysisType_AccountNumberDeductVAT"
  },
  ACCOUNT_NUMBER_NOD_DEDUCT_VAT: {
    value: 13,
    languageString: "analysisType_AccountNumberNonDeductVAT"
  },
  ACCOUNT_NUMBER_REVERSED_VAT: {
    value: 14,
    languageString: "analysisType_AccountNumberReversedVAT"
  }
});

export class VATBoxType extends Enum{}
VATBoxType.initEnum({
  TAXABLE_BASIS: {
    value: 0,
    languageString: 'vatBoxType_TaxableBasis'
  },
  VAT: {
    value: 1,
    languageString: 'vatBoxType_VAT'
  }
});

export class VATReturnDetailsTabs extends Enum{}
VATReturnDetailsTabs.initEnum({
  VIEW_RETURN_BY_TRANSACTION: {
    value: 0
  },
  FINALISE_AND_FILE: {
    value: 1
  }
});

export class VATBookLineType extends Enum{}
VATBookLineType.initEnum({
  SALES: {
    languageString: "vatBookLineType_Sales",
    value: 0
  },
  PURCHASE: {
    languageString: "vatBookLineType_Purchase",
    value: 1
  },
  COMBINED: {
    languageString: "vatBookLineType_Combined",
    value: 2
  }
});

export class ErrorWarningsCategory extends Enum{}
ErrorWarningsCategory.initEnum({
      ALL_ERRORS: {
        "value": 2,
        "languageString": "errorCategory_AllErrors"
      },
      FINANCIAL_ERRORS: {
        "value": 0,
        "languageString": "errorCategory_FinancialErrors"
      },
      INTRASTAT_ERRORS: {
        "value": 1,
        "languageString": "errorCategory_IntrastatErrors"
      },
      IMMEDIATE_FILING_ERRORS: {
        "value": 3,
        "languageString": "errorCategory_ImmediateFilingErrors"
      }
});

export class ErrorKind extends Enum{}
ErrorKind.initEnum({
    ERROR: {
      "value": 0,
      "languageString": "errorKind_Error"
    },
    WARNING: {
      "value": 1,
      "languageString": "errorKind_Warning"
    },
    UNKNOWN: {
      "value": 'UNKNOWN'
    }
})

export class ReturnPeriodTimeType extends Enum{}
ReturnPeriodTimeType.initEnum({
     NO_PERIOD: {
        "languageString": "returnPeriodTimeType_NoPeriod",
        "value": 0
      },
      MONTHLY: {
        "languageString": "returnPeriodTimeType_Monthly",
        "value": 1
      },
      QUARTERLY: {
        "languageString": "returnPeriodTimeType_Quarterly",
        "value": 2
      },
      YEARLY: {
        "languageString": "returnPeriodTimeType_Yearly",
        "value": 3
      },
      YEARLY2: {
        "languageString": "returnPeriodTimeType_Yearly2",
        "value": 4
      },
      YEARLY_DYNAMIC: {
        "languageString": "returnPeriodTimeType_YearlyDynamic",
        "value": 5
      },
      YEARLY_DYNAMIC2: {
        "languageString": "YearlyDynamic2",
        "value": 6
      },
      NO_FILING: {
        "languageString": "NoFiling",
        "value": 7
      },
      BI_MONTHLY: {
        "languageString": "returnPeriodTimeType_BiMonthly",
        "value": 8
      },
      HALF_YEAR: {
        "languageString": "returnPeriodTimeType_HalfYear",
        "value": 9
      }
});

export class ReportingDocumentType extends Enum{}
  ReportingDocumentType.initEnum({
    TYPE_1: {
      value: 0
    },
    SAP_DOCUMENT_TYPE_RV: {
      value: 1
    },
    INTRASTAT_DOCUMENT_TYPE: {
      value: 2
    },
    UNKNOWN: {
      value: 999
    }
  }
);

export class ErrorWarningAction extends Enum{}
ErrorWarningAction.initEnum({
  REOPEN_AND_REDELIVER: {
    value:'REOPEN_AND_REDELIVER'
  },
  RESCHEDULE_AS_NONCORRECTIVE: {
    value:'RESCHEDULE_AS_NONCORRECTIVE'
  },
  RESCHEDULE_AS_CORRECTIVE: {
    value:'RESCHEDULE_AS_CORRECTIVE'
  },
  BULK_FIND_AND_REPLACE: {
    value:'BULK_FIND_AND_REPLACE'
  },
  EXPORT: {
    value: 'EXPORT'
  },
  ERROR_ACTION_HIDE: {
    value: 'ERROR_ACTION_HIDE'
  },
  ERROR_ACTION_UNHIDE: {
    value: 'ERROR_ACTION_UNHIDE'
  },
  ERROR_ACTION_MOVE: {
    value: 'ERROR_ACTION_MOVE'
  },
  ERROR_ACTION_VATRATE: {
    value: 'ERROR_ACTION_VATRATE'
  },
  ERROR_ACTION_INVNR: {
    value: 'ERROR_ACTION_INVNR'
  },
  ERROR_ACTION_SUPINVNR: {
    value: 'ERROR_ACTION_SUPINVNR'
  },
  ERROR_ACTION_VATNR: {
    value: 'ERROR_ACTION_VATNR'
  },
  ERROR_ACTION_DELETE: {
    value: 'ERROR_ACTION_DELETE'
  },
  ERROR_ACTION_MOVE_WARNING_TO_ERROR: {
    value: 'ERROR_ACTION_MOVE_WARNING_TO_ERROR'
  },
  ERROR_ACTION_SAVE_TO_FILE: {
    value: 'ERROR_ACTION_SAVE_TO_FILE'
  },
  ERROR_ACTION_OSS_VATNR: {
        value: 'ERROR_ACTION_OSS_VATNR'
  },
  ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE: {
    value: 'ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE'
  }
});

export class UserRoleEnum extends Enum{}
UserRoleEnum.initEnum({
    ADMIN: {
       get value() {return 'Admin'}
    },
    PREPARER: {
        get value() {return 'Preparer'}
    },
    REPORTING_USER: {
      get value() {return 'Reporting User'}
    },
});

export class IamUserRoleEnum extends Enum{}
IamUserRoleEnum.initEnum({
    ADMIN: {
       get value() {return 'Administrator'}
    },
    PREPARER: {
        get value() {return 'Preparer'}
    },
    READ_ONLY: {
      get value() {return 'ReadOnly'}
    },
    REPORTING_USER: {
      get value() {return 'Reporting'}
    }
});

export class TransactionReportTypeEnum extends Enum{}
TransactionReportTypeEnum.initEnum({
    INVOICELINES: {
       get value() {return 'Invoice lines'}
    },
    INTRASTATLINES: {
        get value() {return 'Intrastat lines'}
    },
    CHANGESLOG: {
        get value() {return 'Changes log'}
    },
    DELETELOG: {
      get value() {return 'Delete log'}
    },
    VATCODEHISTORY:{
      get value(){ return 'VAT code history'}
    },
    GLSTATUSVRSIDE:{
      get value(){ return 'GL status overview VR side'}
    },
    GLSTATUSGLSIDE:{
      get value(){ return 'GL status overview GL side'}
    },
    FILEPROCESSINGLOG:{
      get value(){ return 'File processing log'}
    },
    SIITRANSACTIONS: {
      get value() { return 'SII transactions' }
    },
    SIILOG:{
      get value(){ return 'SII log'}
    },
    MTDLIABILITY:{
        get value(){ return 'MTD - Liability'}
    },
    MTDPAYMENTS:{
        get value(){ return 'MTD - Payments'}
    },
    MTDRETURNS:{
        get value(){ return 'MTD - Returns'}
    }
});

export class CompanyVatGroupTypeEnum extends Enum {}
CompanyVatGroupTypeEnum.initEnum({
  NONE: {
    value: 0,
    languageString: "vatGroupType_None"
  },
  DOMINANT: {
    value: 1,
    languageString: "vatGroupType_Dominant"
  },
  DEPENDANT: {
    value: 2,
    languageString: "vatGroupType_Dependant"
  },
  HOLDING: {
    value: 3,
    languageString: "vatGroupType_Holding"
  }
});


export class ReturnDisplayType extends Enum {}
ReturnDisplayType.initEnum({
  SHOW_ALL: {
    languageString: "returnDisplayType_ShowAll",
    value: 0
  },
  ONLY_NON_CORRECTIONS: {
    languageString: "returnDisplayType_OnlyNonCorrections",
    value: 1
  },
  CORRECTIONS_IN_THIS_PERIOD: {
    languageString: "returnDisplayType_CorrectionsInThisPeriod",
    value: 2
  },
  SHOW_CORRECTIONS_GROUP_BY_PERIOD: {
    languageString: "returnDisplayType_ShowCorrectionsGroupedByPeriod",
    value: 3
  },
  SHOW_CORRECTIONS_GROUP_BY_PERIOD_INCLUDING_ORIGINAL_DOCUMENTS: {
    languageString: "returnDisplayType_ShowCorrectionsGroupedByPeriodIncludingOriginalDocuments",
    value: 4
  }
});

export class OSSGroupType extends Enum {}
OSSGroupType.initEnum({
  GROUP_EXCLUDE: {
    languageString: "returnGroupingType_Exclude",
    value: 0
  },
  GROUP_INCLUDE: {
    languageString: "returnGroupingType_Include",
    value: 1
  },
  DETAILED: {
    languageString: "returnGroupingType_Detailed",
    value: 2
  }
});

export const FeatureFlagEnum = Object.freeze({
  DISABLE_EXPORT_VAT_CURRENT_TRANSACTIONS: 'DisableExportVATCurrentTransactions',
  ENABLE_BULK_ACTIONS: 'EnableBulkActions',
  ENABLE_CORRECTION_FILTERS_VAT_BOOK: 'EnableCorrectionFiltersVATBook',
  ENABLE_EC_LISTING_CORRECTION_ERRORS_WARNINGS: "EnableECListingCorrectionViewErrorsWarnings",
  ENABLE_EC_LISTING_CORRECTION_LINE_DETAILS: "EnableECListingCorrectionLineDetails",
  ENABLE_EC_TRANSACTION_FILTER_OPEN_RETURNS: 'EnableECTransactionFilterOpenReturns',
  ENABLE_ENTER_CREDIT_NOTE_CERTIFICATE_DATE: 'EnableEnterCreditNoteCertificateDate',
  ENABLE_EXPORT_ALL_DYNAMIC_REPORT: 'EnableExportAllDynamicReport',
  ENABLE_EXPORT_ALL_ERRORS_WARNINGS: 'EnableExportAllErrorsWarnings',
  ENABLE_EXPORT_ALL_INVOICE_LINES: 'EnableExportAllInvoiceLines',
  ENABLE_EXPORT_ALL_INVOICE_LINES_INCLUSIVE_ELR: 'EnableExportAllInvoiceLinesInclusiveELR',
  ENABLE_EXPORT_CURRENT_TABLE_LOCAL_LISTING: 'EnableExportCurrentTableLocalListing',
  ENABLE_EXPORT_ALL_SALES_AND_PURCHASE_LEDGER:"EnableExportAllForSalesAndPurchaseLedger",
  ENABLE_CSV_ONLY_EXPORT:"EnableCsvOnlyExportForSalesAndPurchaseLedger",
  ENABLE_EXPORT_ECLISTING: 'EnableExportECListing',
  ENABLE_EXPORT_INTRASTAT: 'EnableExportIntrastat',
  ENABLE_EXPORT_VAT_RETURN_TRANSACTIONS: 'EnableExportVATReturnTransactions',
  ENABLE_INTRASTAT_COMMERCIAL_SUMMARY: "EnableIntrastatCommercialSummary",
  ENABLE_INTRASTAT_MANUAL_DOCUMENTS: 'EnableIntrastatManualDocument',
  ENABLE_IOSS_CORRECTION: 'EnableIOSSCorrection',
  ENABLE_IOSS_CORRECTION_ERRORS_WARNINGS: 'EnableIOSSCorrectionErrorsWarnings',
  ENABLE_ITALY_LOOKUPS: 'EnableItalyLookups',
  ENABLE_LEDGER_REPORTS: 'EnableLedgerReports',
  ENABLE_MANUAL_DOCUMENTS: 'EnableManualDocuments',
  ENABLE_USER_MANAGEMENT_TILES: 'EnableUserManagementTiles',
  ENABLE_NEW_METADATA: "EnableNewMetaData",
  ENABLE_NON_UNION_OSS_CORRECTION_VIEW_ERRORS_WARNINGS: 'EnableNonUnionOSSCorrectionViewErrorsWarnings',
  ENABLE_NON_UNION_OSS_GROUP_FILTER_OPEN_RETURNS: 'EnableNonUnionOSSGroupFilterOpenReturns',
  ENABLE_UNION_OSS_CORRECTION_VIEW_ERRORS_WARNINGS: 'EnableUnionOSSCorrectionViewErrorsWarnings',
  ENABLE_UNION_OSS_GROUP_FILTER_OPEN_RETURNS: 'EnableUnionOSSGroupFilterOpenReturns',
  ENABLE_VAT_BOOK_CORRECTION_ERRORS_WARNINGS: 'EnableVATBookCorrectionViewErrorsWarnings',
  ENABLE_VAT_RETURN_CORRECTION_ERRORS_WARNINGS: 'EnableVATReturnCorrectionViewErrorsWarnings',
  ENABLE_VAT_RETURN_NON_CORRECTION_VIEW_ERRORS_WARNINGS : 'EnableVatReturnNonCorrectionViewErrorsWarnings',
  ENABLE_VIEW_AND_REOPEN_VATBOOK: 'EnableReopenVATBook',
  USE_SYSTEM_FILENAME_FOR_DOWNLOAD_WHEN_PRESENT: "UseSystemFileNameForDownloadWhenPresent",
  USE_V2_DELETE_FILE_ENDPOINT: 'UseV2DeleteFileEndpoint',
  USE_V2_INTRASTAT_ERRORDETAIL_TEMPLATE : 'UseV2IntrastatErrorDetailTemplate',
  USE_v4_FILING_FORM_ENDPOINT: 'UseV4FilingFormEndpoint',
  ENABLE_EXPORT_BOX_VALUE_OPEN_RETURNS: 'EnableExportBoxValueOpenReturns',
  ENABLE_DYNAMIC_REPORT_API_REVIEW_CHANGES: 'EnableDynamicReportAPIReviewChanges',
  USE_DYNAMIC_REPORTING_EXPORT_API: 'UseDynamicReportingExportApi',
  ENABLE_COMPANYCODE_PROCESSED_DOCUMENTS_GRID: 'EnableCompanyCodeProcessedDocumentsGrid',
  ENABLE_COMPANYCODE_OPEN_RETURNS_GRID: 'EnableCompanyCodeOpenReturnsGrid',
  ENABLE_COMPLIANCE_CALENDAR_AS_HOME_PAGE: 'EnableComplianceCalendarAsHomePage',
  ENABLE_NEW_PROCESSED_DOCUMENT_GRID : 'EnableNewProcessedDocumentGrid',
  ENABLE_VAT_RETURN_AUTO_SUBMISSION: 'EnableVATReturnAutoSubmission',
  ENABLE_RETURN_APPROVAL_WORKFLOW: 'EnableReturnApprovalWorkflow',
  ENABLE_EC_LISTING_IMPORT: 'EnableECListingImport',
  ENABLE_LOCAL_LISTING_IMPORT: 'EnableLocalListingImport',
  ENABLE_BOX_DESCRIPTION: 'EnableBoxDescription',
  ENABLE_INLINE_BOX_DESCRIPTION: 'EnableInlineBoxDescription',
  ENABLE_NOTIFICATIONS_BUTTON: 'EnableNotificationsButton',
  ENABLE_PROCESSED_DOCUMENTS_PAGE: 'EnableProcessedDocumentsPage',
  ENABLE_UPLOADED_DOCUMENTS_PAGE: 'EnableUploadedDocumentsPage',
  ENABLE_API_LICENSE_KEY_PAGE: 'EnableApiLicenseKeyPage',
  ENABLE_NEW_NL_DIGIPORT_WINDOW: 'EnableNewNLDigiportWindow'
});

export const ReportFilterType = Object.freeze({
  DATE_RANGE: 'dateRange',
  NUMBER_RANGE: 'numberRange',
  SELECT: 'select',
  DEFAULT: 'string'
});

export const ReportType = Object.freeze({
  INVOICE_LINES: 'InvoiceLines',
  ERROR_WARNINGS: 'ErrorsAndWarnings'
});

// Mirrors backend ReturnType enum on CloseReturnRequestDto for POST /api/v6/filing/CloseReturn
export const CloseReturnTypeEnum = Object.freeze({
  VAT_BOOK: 0,
  VAT_RETURN: 1,
  INTRASTAT: 2
});

export const ManualDocumentDocumentType = Object.freeze({
    SALES: 'SALES',
    PURCHASE: 'PURCHASE'
});

/**
 * This uses the countries json to create enum entry for each supported country, hence we don't need to add the manually
 */
let countryList = {};
Countries.forEach( (countryData) => {
  countryList[countryData.countryCode] = countryData.countryCode;
});
export class CountryCodeEnum extends Enum {}
CountryCodeEnum.initEnum( countryList);

export const PERIOD_OPTIONS = Object.freeze([
  {
    value: "0",
    languageString: 'vatCodeSearch_dropdown_no_period'
  },
  {
    value: "1",
    languageString: 'vatCodeSearch_dropdown_monthly'
  },
  {
    value: "2",
    languageString: 'vatCodeSearch_dropdown_quarterly'
  },
  {
    value: "3",
    languageString: 'vatCodeSearch_dropdown_yearly'
  },
  {
    value: "4",
    languageString: 'vatCodeSearch_dropdown_yearly2'
  }
]);

export const FILETYPES_FOR_LEDGER_EXPORT_ALL = Object.freeze([
    {
        value: "0",
        label: "CSV"
    },
    {
        value: "1",
        label: "PDF-A3"
    },
    {
        value: "2",
        label: "PDF-A4"
    },
    {
        value: "3",
        label: "Excel"
    }
]);

export const OperationTypes = {
    SampleOperation: 1,
    BulkDeleteDocuments: 2,
    BulkDeleteInvoices: 3,
    BulkRedeliverDocuments: 4,
    BulkForceToErrorDocuments: 5,
    BulkRedeliverInvoices: 6,
    BulkForceToErrorInvoices: 7,
    BulkDeleteFiles: 8,
    BulkRedeliverFiles: 9,
    SampleIdempotentOperation: 10,
    SampleBulkExchangeRatesOperation: 11,
    ImportExchangeRates: 12
};

export const PromiseStatus = Object.freeze({
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
});

export const Companies = Object.freeze({
  ALL_COMPANIES : 'All'
});

// Frequency mapping for CSV filename generation
export const FrequencyMap = Object.freeze({
  '1': 'Monthly',
  '2': 'Quarterly', 
  '3': 'Yearly',
  '4': 'Year2',
  '5': 'Year dynamic',
  '6': 'Year2 dynamic',
  '7': 'No Filing',
  '8': 'Bi monthly',
  '9': 'Half yearly',
  '10': 'Four monthly',
  '11': 'Year dynamic quick',
  '12': 'Year2 dynamic quick'
});

// VAT Type mapping for CSV filename generation
export const VatTypeMap = Object.freeze({
  '0': 'Regular',
  '1': 'Non-corrections', 
  '2': 'Corrections'
});